document.addEventListener('DOMContentLoaded', () => {
  const catalogs = document.querySelectorAll('.parts-catalog');

  catalogs.forEach((catalog) => {
    const slides = catalog.querySelectorAll(
      '[data-parts-catalog-drawing]'
    );

    const thumbnails = catalog.querySelectorAll(
      '[data-parts-catalog-drawing-target]'
    );

    if (!slides.length || !thumbnails.length) {
      return;
    }

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        const targetIndex = thumbnail.dataset.partsCatalogDrawingTarget;

        slides.forEach((slide) => {
          slide.classList.toggle(
            'is-active',
            slide.dataset.partsCatalogDrawing === targetIndex
          );
        });

        thumbnails.forEach((item) => {
          item.classList.toggle(
            'is-active',
            item === thumbnail
          );
        });
      });
    });
  });
});